import { DangerousHtml, Grid, Typography } from '@lingoda/ui';
import { Checkbox } from '@lingoda/forms';
import { type CheckoutAgreements } from './types';

interface Props {
    agreements: CheckoutAgreements;
}

export interface FormValues {
    agreements?: boolean[];
}

export const AgreementsForm = ({ agreements }: Props) => (
    <Grid container spacing={3}>
        {agreements.map(({ acceptanceText, id }) => (
            <Grid item xs={12} key={`agreements-${id}`}>
                <Checkbox
                    name={`agreements.${id}`}
                    label={
                        <Typography variant="body2">
                            <DangerousHtml as="span">{acceptanceText}</DangerousHtml>
                        </Typography>
                    }
                />
            </Grid>
        ))}
    </Grid>
);
